module.exports = __webpack_public_path__ + "img/person.5f8e8a1b.svg";